import React from "react";
import { HeroSectionHome } from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import "./styles/HomePage.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import data from "../data/imageData.json";
import CertificationsSection from "../components/CertificationsSection";
import ResponsiveImage from "../components/ResponsiveImage";

const HomePage = () => {
  return (
    <div className="homePage">
      <div className="header">
        <ResponsiveImage src={data.homepage.url} alt="" className="heroImage" priority />
        <Navbar />
        <HeroSectionHome />
      </div>
      <main className="content">
        <ServicesSection />
        <CertificationsSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
